import { useQuery } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';
import { toAddressAutocompleteItem } from '@/services/address.service';

function getCompletion(query: string) {
  return getSMPBackendAPIAdmin().hereControllerAutocompleteV1({ q: query });
}

export function useLocationAutocomplete(query: string) {
  return useQuery({
    queryKey: ['autocomplete', query],
    queryFn: () => getCompletion(query),
    select: (data) => data?.items?.map(toAddressAutocompleteItem),
    enabled: query.length > 3,
  });
}
